import { job_field, academic_field } from "../../static/static_field";

const formFields = [
  {
    key: "q_name",
    label: "姓名",
    type: "input",
  },
  {
    key: "q_loc",
    label: "位置",
    type: "input",
  },
  {
    key: "q_school",
    label: "学校",
    type: "input",
  },
  {
    key: "q_major",
    label: "专业",
    type: "input",
  },
  {
    key: "q_schoolm_start_time",
    label: "初中年级",
    type: "input",
  },
  {
    key: "q_schoolm_class",
    label: "初中班级",
    type: "input",
  },
  {
    key: "q_schoolh_start_time",
    label: "高中年级",
    type: "input",
  },
  {
    key: "q_schoolh_class",
    label: "高中班级",
    type: "input",
  },
  {
    key: "q_career",
    label: "职业",
    type: "select",
    options: job_field.map(item => ({
      value: item.value.toString(),
      label: item.label,
    })),
  },
  {
    key: "q_job",
    label: "职位",
    type: "select",
    options: academic_field.map(item => ({
      value: item.value.toString(), 
      label: item.label,
    })),
  },
];

export default formFields;
